import React from "react";
import { capitalizeFirstLetter } from "../../../utils/helper";

function FOView({
  partner,
  onClose,
  onApprove,
  roleSelections,
  handleRoleChange,
  loadingUpdate,
}) {
  if (!partner) return null;  
  const isApproved = partner?.isApproved;

const ApprovalBadge = ({ status }) => {
  let className = "app-badge  ";
 let displayText = status; 
 
   if (status === "GANGLEADER") {
    className += "bg-label-navy ";
     displayText = "Captain";
  } 
    else if (status === "FIELDOFFICER") {
    className += "bg-label-wave ";
    displayText = "Field Officer";
  }else {
    className += "bg-light text-dark";
  }

  return <span className={className}>{displayText}</span>;
};

  return (
    <>    
      <div className="modal-backdrop show"></div>

      <div
        className="modal show d-block"
        id="FOViewModal"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content ">           
            <div className="modal-header border-bottom-0 py-3">
              <h6 className="modal-title fw-semibold">
                Field Officer Details:{" "}
                <span className="text-capitalize">
                  {partner.name || partner.mobileNumber}
                </span>
              </h6>
              <button
                type="button"
                className="btn-close border"
                onClick={onClose}
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="p-3">
                <div className="row gy-3 ">
                  <div className="col-12 d-flex justify-content-between">
                    <span className="fw-semibold text-secondary">Role:</span>
                    <span>
                      {partner?.role &&(
                    <ApprovalBadge 
                              status={partner?.role }                            
                            />)}
                    </span>
                  </div>
                  <div className="col-12 d-flex justify-content-between">
                    <span className="fw-semibold text-secondary">Employee ID:</span>
                    <span className="text-black fw-bold">
                      {partner?.employeeId || "-"}
                    </span>
                  </div>
                  <div className="col-12 d-flex justify-content-between">
                    <span className="fw-semibold text-secondary">Phone:</span>
                    <span className="text-black fw-bold">
                      <a href={`tel:+91${partner?.mobileNumber}`} onClick={(e) => e.stopPropagation()} className="text-black">{partner.mobileNumber}</a>
                    </span>
                  </div>
               
                </div>
              </div>

                 {/* {!isApproved && (
                <div
                  className="border rounded-4 p-4"
                  style={{
                    background: "#fff7f7",
                    borderColor: "#ffd7d7",
                  }}
                >
                  <div className="d-flex align-items-center mb-3">
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center me-3"
                      style={{
                        width: "42px",
                        height: "42px",
                        background: "#ffe5e5",
                        color: "#dc3545",
                      }}
                    >
                      <i className="bx bx-user-check fs-4"></i>
                    </div>

                    <div>
                      <h6 className="mb-1 fw-bold text-danger">
                        Approval Pending
                      </h6>

                      <small className="text-muted">
                        Select a role to approve this partner
                      </small>
                    </div>
                  </div>

                  <label className="form-label fw-semibold mb-2">
                    Assign Role
                  </label>

                  <div className="row g-3">
                    
                  
                    <div className="col-12">
                      <div
                        className={`border rounded-4 p-3 cursor-pointer transition-all ${
                          roleSelections[partner._id] === "FIELDOFFICER"
                            ? "border-primary bg-primary-subtle"
                            : "bg-white"
                        }`}
                        onClick={() =>
                          handleRoleChange(
                            partner._id,
                            "FIELDOFFICER"
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center">
                            <div
                              className="rounded-circle d-flex align-items-center justify-content-center me-3"
                              style={{
                                width: "48px",
                                height: "48px",
                                background: "#eef3ff",
                                color: "#5f82c5",
                              }}
                            >
                              <i className="bx bx-map fs-4"></i>
                            </div>

                            <div>
                              <h6 className="mb-1 fw-bold">
                                Field Officer
                              </h6>

                              <small className="text-muted">
                                Access for field operations and booking handling
                              </small>
                            </div>
                          </div>

                          <div>
                            <input
                              type="radio"
                              checked={
                                roleSelections[partner._id] ===
                                "FIELDOFFICER"
                              }
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )} */}

              <hr className="my-3" />
            </div>          
            <div className="modal-footer border-0 pt-0">
              <button
                type="button"
                className="btn btn-outline-secondary px-3"
                onClick={onClose}
              >
                Close
              </button>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FOView;

